import React from "react";
import { Redirect } from "react-router-dom";
import { useSelector } from "react-redux";

import {
  UNAUTHORIZED_URL,
  MUST_CHANGE_PASSWORD_URL,
  LANDING_URL,
} from "config";
import { withLang } from "managers/routeManager";
import { handleProfileCheck } from "./callApi";

const AuthGuard = ({ children }) => {
  const state = useSelector((state) => state);
  const account = state.account;

  const { isLoggedIn, user } = account;
  const currentPath = window.location.pathname;

  React.useEffect(() => {
    accessProfile();
  }, []);

  const accessProfile = () => {
    if (isLoggedIn && user && user.id && !user.mustChangePassword) {
      handleProfileCheck(user.id);
    }
  };

  if (
    isLoggedIn &&
    user &&
    user.mustChangePassword &&
    currentPath !== withLang(state, MUST_CHANGE_PASSWORD_URL)
  ) {
    return <Redirect to={withLang(state, MUST_CHANGE_PASSWORD_URL)} />;
  }

  // if (isLoggedIn
  //     && user
  //     && !user.mustChangePassword
  //     && currentPath === withLang(state, MUST_CHANGE_PASSWORD_URL)) {
  //
  //     return <Redirect to={withLang(state, LANDING_URL)} />;
  // }

  if (!isLoggedIn) {
    return <Redirect to={withLang(state, UNAUTHORIZED_URL)} />;
  }

  return children;
};

export default AuthGuard;
